// extracted by mini-css-extract-plugin
export var blueTail = "SpeechBubble-module--blueTail--50968";
export var blueTailReverse = "SpeechBubble-module--blueTailReverse--047ce";
export var blueWrapper = "SpeechBubble-module--blueWrapper--e1bb7";
export var lightBlueTail = "SpeechBubble-module--lightBlueTail--e2b09";
export var lightBlueWrapper = "SpeechBubble-module--lightBlueWrapper--91902";
export var redTail = "SpeechBubble-module--redTail--92385";
export var redWrapper = "SpeechBubble-module--redWrapper--c5fae";
export var reverse = "SpeechBubble-module--reverse--26a11";